<script lang="ts">
    import { postLogin } from "../../../functions/CommerceAPIs/bigCommerce/customer"
    import { newNotification } from "../../../store"
    import Input from "../blocks/form/Input.svelte"
    import { onChange, validateField, validateInput } from "./helper"

    const loginDetails: {
        email: string
        password: string
    } = {
        email: "",
        password: "",
    }

    function loginUser() {
        const validations = [
            { id: "email", value: loginDetails.email, validator: validateInput },
            { id: "password", value: loginDetails.password, validator: validateInput },
        ]

        let isValid = true

        for (const { id, value, validator } of validations) {
            // @ts-ignore
            if (!validateField(id, value, validator)) isValid = false
        }

        if (isValid) {
            postLogin({
                email: loginDetails.email,
                password: loginDetails.password,
            })
                .then(() => {
                    newNotification({ html: "Login erfolgreich", class: "success" })
                })
                .catch((error) => {
                    if (error.data.status === 403)
                        newNotification({ html: "Falsche E-Mail oder falsches Passwort.", class: "error" })
                    else newNotification({ html: "Ein Fehler ist aufgetreten.", class: "error" })
                })
        }
    }
</script>

<section class="small-wrapper">
    <form
        class="login"
        on:submit|preventDefault|stopPropagation="{loginUser}"
    >
        <h2>Melde dich mit deinem Account an</h2>
        <div class="content">
            <section class="details">
                <Input
                    placeholder="E-Mail*"
                    id="email"
                    onChange="{onChange}"
                    bind:value="{loginDetails.email}"
                />
                <Input
                    placeholder="Passwort*"
                    id="password"
                    onChange="{onChange}"
                    bind:value="{loginDetails.password}"
                />
            </section>
        </div>
        <section class="submit">
            <button
                type="submit"
                class="cta primary">Anmelden</button
            >
        </section>
    </form>
</section>

<style lang="less">
    .small-wrapper {
        flex-grow: 1;
        display: flex;
        align-items: flex-start;
        form {
            padding: 2.4rem 0rem;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 2.4rem;
            h2 {
                color: var(--text-invers-100);
            }
            .content {
                width: 100%;
                .details {
                    display: flex;
                    gap: 1.2rem;
                    width: 100%;
                }
            }
            .submit {
                display: flex;
                justify-content: space-between;
                width: 100%;
                button {
                    width: fit-content;
                }
            }
        }
    }
</style>
